import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { TFunction } from 'i18next';

import { HttpError, getTheme } from '@talend/react-components';

import { I18N_NAME_SPACE, PATHS } from '../../constants';
import theme from './ErrorPage.module.css';
import { HttpErrorConfiguration } from './ErrorPage.types';
import { forbiddenStyle } from './forbiddenStyle';
import { notFoundStyle } from './notFoundStyle';

const css = getTheme(theme);

function getHttpErrorProps(url: string, t: TFunction): HttpErrorConfiguration {
	if (url === PATHS[403]) {
		return {
			props: {
				status: 403,
				title: t('ERROR_PAGE_ACCESS_DENIED', { defaultValue: 'Access denied' }),
				message: t('ERROR_PAGE_ACCESS_DENIED_MESSAGE', {
					defaultValue: 'You are not allowed to access this page',
				}),
			},
			style: forbiddenStyle,
		};
	}
	return {
		props: {
			status: 404,
			title: t('ERROR_PAGE_NOT_FOUND', { defaultValue: 'Oops ...' }),
			message: t('ERROR_PAGE_NOT_FOUND_MESSAGE', {
				defaultValue: 'The page you are looking for cannot be found',
			}),
		},
		style: notFoundStyle,
	};
}

export function ErrorPage(): React.ReactElement | null {
	const { t } = useTranslation(I18N_NAME_SPACE);
	const location = useLocation();
	const httpErrorConfig = getHttpErrorProps(location.pathname, t);

	return (
		<div className={css('tdx-error-page')}>
			<HttpError {...httpErrorConfig.props} style={httpErrorConfig.style} />
		</div>
	);
}
